import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Welcome from "./component/Page/Welcome";
import CardMenu from "./component/Page/CardMenu";
import Map from "./component//Map";
import "@fortawesome/fontawesome-free";
import DashBoard from "./component/Page/DashBoard";

import { useEffect, useState } from "react";

function App() {
  const [adminaccess, setAdminaccess] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("token") === "2y1bAAVUSHabbElp2QPFW0UgJls1" ||
      localStorage.getItem("token") === "AsjHNfBsTvYIgJ3PQw8umrBfVdk1"
    ) {
      setAdminaccess(true);
    }
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/carte" element={<CardMenu />} />
          <Route path="/map" element={<Map />} />
          <Route
            path="/admin"
            element={adminaccess ? <DashBoard /> : <Welcome />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
